import React from 'react';
import { Typography, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { atomOneDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';

const Root = styled('div')(({ theme }) => ({
    padding: theme.spacing(2),
  }));
  
  const StyledSyntaxHighlighter = styled(SyntaxHighlighter)(({ theme }) => ({
    overflowX: "hidden !important",
    height: '330px',
    wordBreak: 'break-word',
  }));
  

export default function SelectedMessage ({selectedMessage}) {
    const message = selectedMessage 
        && selectedMessage.body 
        && Buffer.isBuffer(selectedMessage.body) ? {
            ...selectedMessage,
            body: selectedMessage.body.toString('utf8')
        } : selectedMessage;
    return <Root>
        <Grid container spacing={0} justifyContent="space-between">
            <Grid size={{ xs: 11 }}>
                <Typography variant="h6">
                    Selected Message
                </Typography>
            </Grid>
            <Grid width={'100%'} item size={{ xs: 12 }}>
                <StyledSyntaxHighlighter
                    wrapLongLines={true}
                    wrapLines={true}
                    language="json" style={atomOneDark}>
                        {message ? JSON.stringify(message, null, 4) : "No Content"}
                </StyledSyntaxHighlighter>
            </Grid>
        </Grid>
    </Root>
}